import React from 'react';
import { FILE_SIZE_MAX_MB, FILE_TYPES_ACCEPTED } from '../../utils/constants';

const FileUploadDescription = () => {
  const typeList = new Intl.ListFormat('en', { type: 'disjunction' }).format(
    FILE_TYPES_ACCEPTED,
  );
  return (
    <div className="vads-u-margin-bottom--4">
      <strong>Tips for uploading:</strong>
      <ul>
        <li>Use a {typeList} file</li>
        <li>Upload 1 file at a time</li>
        <li>
          Upload files that add up to no more than {FILE_SIZE_MAX_MB}{' '}
          <dfn>
            <abbr title="Megabytes">MB</abbr>
          </dfn>{' '}
          total
        </li>
        <li>
          If you only have a paper copy, scan or take a photo and upload the
          image
        </li>
      </ul>
    </div>
  );
};

export default FileUploadDescription;
